<template>
  <div id="root">
    <loading-screen/>
    <Header></Header>
    <div id="router">
      <router-view class="router"/>
    </div>
    <Footer></Footer>
  </div>
</template>

<script>
import {LoadingScreen} from 'motivate-framework-components';
import Header from './components/Header';
import Footer from './components/Footer';

// @vuese
// This wraps the complete app and contains the loading screen

export default {
  name: 'App',

  components: {
    Header,
    Footer,
    LoadingScreen
  },
  data() {
    return {
      displaySecond: false
    };
  },
  methods: {},
  created() {
    document.title = "Bork | Admin"
    setInterval(() => {
      this.$store.commit('setCurrentTime', moment());
      if (moment().format('HH:mm:ss') === '00:00:00') {
        this.$store.dispatch('closeApp');
        location.reload();
      }
    }, 1000)
  }
};
</script>

<style lang="scss">
@import "./assets/scss/main.scss";

body {
  overflow-y: hidden;
  background-color: $background;
  overflow-x: hidden;
}

#root {
  display: grid;
  height: 100%;
  grid-template-columns: 1fr;
  grid-template-rows: $headerHeight 1fr $footerHeight;
  grid-column-gap: 0px;
  grid-row-gap: 0px;
}

#router {
  height: $routerHeight;
}

footer {
  background-color: #e4e4e4;
  position: absolute;
  bottom: 1rem;
  font-size: 1.5rem;
  height: 2rem;
  color: $primary;
}


</style>

